export const data = {
  title: {
    pt: "A minha Educação",
    eng: "My Education",
  },
  explorebtn: {
    pt: "",
    eng: "Check it out",
  },
  certbtn: {
    pt: "Certificado",
    eng: "Certificate",
  },
  courses: [
    {
      title: {
        pt: "Estudante em Mestrado de Engenharia de Gestão e Sistemas de Informação",
        eng: "Master's Student of Management and Information Systems",
      },
      duration: {
        pt: "",
        eng: "September 2018 - December 2024",
      },
      school: {
        pt: "Universidade do Minho",
        eng: "University of Minho",
      },
      desc: [
        {
          pt: "",
          eng: "In 2018, I embarked on my university journey in Management Engineering and Information Systems. Over the course of four years, I honed a diverse and comprehensive skill set, not only in technical domains like programming, data science, and networking, but also in management disciplines such as project management, logistics, and marketing. This blend of expertise has equipped me with the tools to navigate both the technological and managerial landscapes with confidence."
        },

        {
          pt: "",
          eng: "While my academic focus and personal preference leaned towards the technological aspects of my studies, I also deeply appreciated the value of the management concepts I encountered, which have proven to be incredibly useful in my professional growth."
        },

        {
          pt: "",
          eng: "Throughout my degree, I worked on a variety of projects utilizing a wide range of programming languages and technologies. These included JavaScript (and Node.js for backend, HTML and CSS for frontend) for web development, Python for machine learning, data science, and data mining, as well as Java and Python for big data applications. A core focus of my studies was database management, particularly relational SQL databases. While Linux, networking, and assembly were also covered, they were secondary in comparison to the other technical areas."
        },

        {
          pt: "",
          eng: "On the management side, I gained significant experience with project management methodologies such as SCRUM and Waterfall, as well as process modeling with tools like UML (Unified Modeling Language) and BPMN (Business Process Model and Notation). I became proficient in using tools like Microsoft Project to create Gantt Charts, which became a central feature of all my project planning documents. These experiences, coupled with a deeper understanding of organizational processes, provided me with a well-rounded approach to both technology and management."
        },

        {
          pt: "",
          eng: "Building on this foundation, I pursued a master’s degree where I focused on integrating Adaptive Business Intelligence in Healthcare. I am proud to say that I completed my thesis with the highest possible distinction, earning a perfect grade of 20/20. This work not only furthered my expertise in both business intelligence and healthcare but also solidified my ability to apply technical solutions to real-world challenges, bridging the gap between cutting-edge technology and strategic management in the healthcare sector."
        },

        {
          pt: "",
          eng: "With this combination of technological acumen, management insight, and a specialized focus on Adaptive Business Intelligence, I am well-equipped to tackle complex challenges in various industries."
        }
      ],
      courseurl: "https://miegsi.dsi.uminho.pt",
      certurl: "",
    },
        {
      title: {
        pt: "Certificação eJPT",
        eng: "INE eJPT Certification",
      },
      duration: {
        pt: "",
        eng: "April 2025 - June 2025",
      },
      school: {
        pt: "INE",
        eng: "INE",
      },
      desc: [
        {
          eng: "The eLearnSecurity Junior Penetration Tester (eJPT) is a practical, hands-on certification focused on the foundations of ethical hacking and penetration testing. Unlike multiple-choice exams, it tests real-world skills by requiring candidates to investigate networks, identify vulnerabilities, and exploit them in order to complete specific objectives. Passing the eJPT means proving the ability to think like an attacker while following structured methodologies that are valuable in the cybersecurity industry."
        },
        {
          eng: "My journey toward this certification was both challenging and rewarding. Over the course of more than 200 hours of study and research, I immersed myself in penetration testing concepts, methodologies, and tools. I documented everything carefully in Obsidian, building my own knowledge base of notes, commands, and strategies that I could rely on. This process helped me not only retain what I learned, but also develop a system I can continue to grow throughout my career."
        },
        {
          eng: "Preparation for the exam wasn’t limited to theory. I spent countless hours practicing on vulnerable machines and cracking dozens of boxes in labs and platforms to refine my skills. Each challenge brought new lessons—whether it was sharpening my enumeration process, mastering privilege escalation techniques, or streamlining my workflow with scripts and tools. By the time exam day arrived, I had already worked through scenarios that closely mirrored the test environment."
        },
        {
          eng: "That preparation paid off. When I finally sat for the exam, I felt confident and well-equipped to handle every task. Thanks to the hundreds of hours of effort and practice, I was able to approach the challenges methodically and successfully aced the exam. Earning the eJPT was not only a milestone in my cybersecurity journey, but also proof of the value of persistence, structured learning, and hands-on practice."
        }
      ],
      courseurl: "https://ine.com/security/certifications/ejpt-certification",
      certurl: "https://certs.ine.com/aff4c099-23cc-4d0a-bb1e-f33683831736#acc.bGxhIOV1",
    },

    {
      title: {
        pt: "",
        eng: "The Web Developer Bootcamp 2022",
      },
      duration: {
        pt: "",
        eng: "March 2022 - June 2022",
      },
      school: {
        pt: "",
        eng: "Udemy",
      },
      desc: [
        {
          pt: "",
          eng: "This is a Udemy course I went through in 2022 about Web Development, a great passion of mine, that helped me to finalize a few concepts and idead about this area.",
        },

        {
          pt: "",
          eng: "I already have quite a lot of experience in Web Development so this wasn't completely necessary for me to do but there were a few things that I got from this course that made it worth it like what are the best practices in modern 2022 Web Dev? How I should be doing things and not just how to do them.",
        },

        {
          pt: "",
          eng: "For all intents and purposes this course is enormous and it covers erverything from centering a div in css with Frontedn stuff to CRUD behaviour and safe cookie storage in the backend",
        },

        {
          pt: "",
          eng: "This course is more general than the others I made, not choosing 1 technology and sticking with it but cycling throgh a few of them to give the whole idea and explanation, for example it covers SQL and NoSQL databases as well as relational and non-relational databases, different forms of authentication and the secure way to it, among other examples",
        },

        {
          pt: "",
          eng: "I had a lot of fun completing it and I recommend it to everyone that wishes to dabble in the world of Web Development"
        },
      ],
      courseurl: "https://www.udemy.com/course/the-web-developer-bootcamp",
      certurl:
        "https://www.udemy.com/certificate/UC-c8ada681-95d7-4218-b516-29e0bc3f326b/",
    },

    {
      title: {
        pt: "",
        eng: "Angular & NodeJS - The MEAN Stack",
      },
      duration: {
        pt: "",
        eng: "June 2020 - August 2020",
      },
      school: {
        pt: "",
        eng: "Udemy",
      },
      desc: [
        {
          pt: "",
          eng: "This course focuses on the MEAN application Stack - MongoDB/Express.js/Angular/Node.js. I already knew about this stack and how it worked but never have dove into it , being the most popular Technology Stack, I decided to do a course on it ",
        },

        {
          pt: "",
          eng: "As expected, this course teaches the best practices when going about the MEAN Stack and security measures to make sure your application is not vulnerable to common web attacks.",
        },

        {
          pt: "",
          eng: "The MEAN stack uses MongoDB as a non-relational database, Express.js as a routing technology for node.js and backend framework, Angular as the frontend framework and Node.js to power it all.",
        },

        {
          pt: "",
          eng: "I really enjoyed this course, its well structured and explained but after all I didn't enjoy the MEAN stack as much as I thought I would. Nowadays I much prefer MERN, which uses React instead of Angular"
        },
      ],
      courseurl:
        "https://www.udemy.com/course/angular-2-and-nodejs-the-practical-guide",
      certurl:
        "https://www.udemy.com/certificate/UC-d34f5145-9aa7-47d0-bb63-7a3af15357ea/",
    },

    {
      title: {
        pt: "",
        eng: "Angular- The complete Guide",
      },
      duration: {
        pt: "",
        eng: "June 2020 - August 2020",
      },
      school: {
        pt: "",
        eng: "Udemy",
      },
      desc: [
        {
          pt: "",
          eng: "This course taught me the basics and advanced concepts about Angular. When I started this course I had a lot of interest in Angular being the most popular framework for a very long time, so when I saw it on Udemy I bought it.",
        },

        {
          pt: "",
          eng: "The course focuses on Angular's basics and the component-based structure that all javascript frameworks seem to have. In addition to the component-based structure, javascript frameworks also have variable binding that changes DOM components based on state variables.",
        },

        {
          pt: "",
          eng: "With angular we have a lot of freedom, we don't have to worry about the DOM state ever, we have conditional rendering based on state (with ng-if) and loop based components to render multiple equal objects (with ng-for). The more advanced concepts would be storage management with cookies, local and session storage as well as routing",
        },

        {
          pt: "",
          eng: "In the end I enjoyed this course very much, it's very well organized and explained but, knowing other frontend frameworks now, I much prefer React for smaller projects."
        },
      ],
      courseurl: "https://www.udemy.com/course/the-complete-guide-to-angular-2",
      certurl:
        "https://www.udemy.com/certificate/UC-ab9946d1-c727-4c3b-af52-85b8f6f5e8aa/",
    },

    {
      title: {
        pt: "",
        eng: "Ethical Hacking",
      },
      duration: {
        pt: "",
        eng: "June 2020 - August 2020",
      },
      school: {
        pt: "",
        eng: "Udemy",
      },
      desc: [
        {
          pt: "",
          eng: "I always had a lot of interest in all things security, it blew my mind that some people could bend machines and code to do what they wanted. So get the basic concepts and start my journey in the world of cyber security I bought this course",
        },

        {
          pt: "",
          eng: "This course covers a lot of concepts and aspects of modern ethical hacking from Kali Linux and Linux usage in ethical hacking to internet spoofing and communication interceptioninside networks.",
        },

        {
          pt: "",
          eng: "This course also alerted me for all the dangers of the cyber space, now knowing how to do some dangerous things and how easy they are to do to someone unprotected I feel more portected than ever.",
        },
      ],
      courseurl:
        "https://www.udemy.com/course/learn-ethical-hacking-from-scratch",
      certurl:
        "https://www.udemy.com/certificate/UC-e80e8d34-2f11-481f-aa73-441cccf2fd40/",
    },

    {
      title: {
        pt: "Applied Machine Learning: Fundamentos",
        eng: "Applied Machine Learning: Foundations",
      },
      duration: {
        pt: "",
        eng: "October 2022",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: 'Anyone who can write basic Python is capable of fitting a simple machine learning model on a clean dataset. The competitive edge comes in the ability to customize and optimize those models for specific problems. The workflow used to build effective machine learning models and the methods used to optimize those models are typically not algorithm or problem specific. In this course, the first installment in the two-part Applied Machine Learning series, instructor Derek Jedamski digs into the foundations of machine learning, from exploratory data analysis to evaluating a model to ensure it generalizes to unseen examples. Instead of zeroing in on any specific machine learning algorithm, Derek focuses on giving you the tools to efficiently solve nearly any kind of machine learning problem.'
        },

        {
          pt: "",
          eng: 'Through this course I was able to refine and reinforce the Machine Learning foundations I already had from academic and personal projects/studies.'
        },

        {
          pt: "",
          eng: 'It was an oportunity to conduct an entire Machine Learning project in a supervised manner and following the Industry\'s guidelines and methodologies. In retrospective, I feel like I learned the most and grew the most in Data Understanding/Exploration and its importance for a well achieved Machine Learning project via analysis techniques, golden questions and standard rules.'
        },
      ],
      courseurl:
        "https://www.linkedin.com/learning/applied-machine-learning-foundations",
      certurl:
        "https://www.linkedin.com/learning/certificates/01279c7b2550e67358848ac4c890ef9b568fde498841cd78052f9b9ac4a61065",
    },

    {
      title: {
        pt: "Arquitetura de Software: Padrões para Desenvolvedores",
        eng: "Software Architecture: Patterns for Developers",
      },
      duration: {
        pt: "",
        eng: "March 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "As a developer, you're ultimately building software to solve problems for your users. But a successful application also needs to be easy for you and other developers to work with. Enter software architecture patterns. These trusted solutions allow you to translate complex architectural problems to recognizable patterns. In this course, instructor Peter Morlion covers a variety of software architecture patterns, showing you how to apply the correct architecture to new systems and recognize patterns in existing systems. Peter goes over application landscape patterns such as microservices. He also covers application structure patterns like event sourcing, as well as UI patterns like model-view-controller (MVC). Along the way, he shares pros and cons that help you determine which patterns to use. "
        },

      ],
      courseurl:
        "https://www.linkedin.com/learning/software-architecture-patterns-for-developers",
      certurl:
        "https://www.linkedin.com/learning/certificates/a6f325157a9b6349fd4a4c5dc2db1f4f45ab9b94d142dfe2be9c1b6082c1084f",
    },

    {
      title: {
        pt: "Aprendendo RabbitMQ",
        eng: "Learning RabbitMQ",
      },
      duration: {
        pt: "",
        eng: "March 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "RabbitMQ is one of the most popular open-source message brokers in use today. This lightweight software can help companies that have adopted a microservices model stitch together and enable communication between their services. In this course, join instructor Peter Morlion as he demonstrates how to properly install and work with RabbitMQ as a developer. After delving into the fundamental concepts behind message-based systems and the AMQP message protocol, Peter explains why you might want to use RabbitMQ, as well as how to install it. He then showcases how to implement the tool, covering both basic usage, such as how to publish to and consume from a RabbitMQ exchange, as well as more advanced topics like setting up and using authentication in RabbitMQ."
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/learning-rabbitmq",
      certurl:
      "https://www.linkedin.com/learning/certificates/144dc3aa4b050801f52533e05a6f0402bc4177e9c5ec65960c405109a5e4ee8f"
    },

    {
      title: {
        pt: "implementar Modelos de Machine Learning Escaláveis para Ciência de Dados",
        eng: "Deploying Scalable Machine Learning for Data Science",
      },
      duration: {
        pt: "",
        eng: "March 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "Machine learning models often run in complex production environments that can adapt to the ebb and flow of big data. The tools and practices that help data scientists rapidly build machine learning models are not sufficient to deploy those models at scale. To deliver scalable solutions, you need a whole new toolset. This course provides data scientists and DevOps engineers with an overview of common design patterns for scalable machine learning architectures, as well as tools for deploying and maintaining machine learning models in production. Instructor Dan Sullivan reviews three technologies that enable scalable machine learning: services that expose models through APIs, containers for deploying models, and orchestration tools like Kubernetes that help manage containers and clusters. Plus, get tips for monitoring the performance of your services in production environments."
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/deploying-scalable-machine-learning-for-data-science",
      certurl:
      "https://www.linkedin.com/learning/certificates/e02b02eba07b600bacc754a3035895483cdfce2cdfe79732694541f69f466308"
    },

    {
      title: {
        pt: "AWS para desenvolvedores: DynamoDB",
        eng: "AWS for Developers: DynamoDB",
      },
      duration: {
        pt: "",
        eng: "March 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "DynamoDB is a fully managed NoSQL database solution hosted on the AWS cloud. It allows developers quickly scale to support millions of requests without having to worry about provisioning, clustering, patching, and replication. DynamoDB is also known for being an ideal solution for web APIs due to its robust support of JSON. In this course, learn how to leverage this solution so you can reap the high-performance benefits. Robby Millsap covers planning, database fundamentals, coding, and support. He takes you through the process of modeling data, creating tables, using Node.js, indexing, fetching, searching, scanning, querying, authentication, monitoring, and more.",
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/aws-for-developers-dynamodb",
      certurl:
      "https://www.linkedin.com/learning/certificates/1e18ab1f432bdecb44828ed53d15a1f506c23b78ca29a6e3261362fc6bd9edd2?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BGOM80kumSpuXisRO%2F%2FLcWQ%3D%3D"
    },

    {
      title: {
        pt: "AWS para desenvolvedores: DynamoDB",
        eng: "AWS Essential Training for Developers",
      },
      duration: {
        pt: "",
        eng: "March 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "Learn the best ways to host your application within AWS. Jeremy “JV” Villeneuve guides you through how to make the best use of services like IaaS, DBaaS, PaaS, and SaaS using hands-on examples. Plus, explore DevOps and security within AWS and prepare for the AWS Cloud Practitioner Certification (CLF-C02) exam by using the sample questions included at the end of each chapter."
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/aws-essential-training-for-developers",
      certurl:
      "https://www.linkedin.com/learning/certificates/4c0ba42b4b8aba592b0cba6f82aa6a1b0dbcf879547cdc80c40ee5519a3ee6b3?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BDImpVkHSR2GVilCVnh%2B6tQ%3D%3D",
    },

    {
      title: {
        pt: "Testar em Agile",
        eng: "Agile Testing",
      },
      duration: {
        pt: "",
        eng: "April 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "Learn how to create higher-quality software at a faster clip by implementing agile testing in your organization. Throughout this course, instructor Ash Coleman helps you boost your understanding of the role and methods of software testers, as well as how testing can enhance your agile workflow. To kick things off, Ash goes over the role of the tester in agile teams, detailing how testers govern, monitor, and encourage quality practices. Next, she steps through the agile testing approach and pinpoints where testers can add value. She also helps to acquaint you with key testing processes and responsibilities, including bug tracking; explores both manual testing and test automation; and discusses how continuous integration can be incorporated into the mix."
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/agile-testing-2",
      certurl:
      "https://www.linkedin.com/learning/certificates/2788436a7e129e0be176cdf2536a33a11d23b41daf0352ddd8e8483bcfb7d171?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BDImpVkHSR2GVilCVnh%2B6tQ%3D%3D"
    },

    {
      title: {
        pt: "A API OWASP Security: Uma visão global",
        eng: "The OWASP API Security Top 10: An Overview",
      },
      duration: {
        pt: "Agosto 2023",
        eng: "August 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "Want to learn more about securing APIs? Check out the OWASP API Security Top 10, a list of security vulnerabilities compiled and published by the Open Web Application Security Project. In this course, instructor Davin Jackson shows you how APIs really work so you can get up and running with securing them and better protect your applications. Find out why it’s so important to develop your security management skills, especially as more and more applications become increasingly API driven. Get tips along the way on dealing with common API vulnerabilities, including broken object-level authorization, broken authentication, excessive data exposure, lack of resources and rate limiting, mass assignment, and more."
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/the-owasp-api-security-top-10-an-overview",
      certurl:
      "https://www.linkedin.com/learning/certificates/03086a3cbcdfa5c2a2f25827f758fe6a53a37030eeabb92aa23ba1364eeee04b?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BDImpVkHSR2GVilCVnh%2B6tQ%3D%3D"
    },

    {
      title: {
        pt: "Aprender GitHub Actions",
        eng: "Learning GitHub Actions",
      },
      duration: {
        pt: "Setembro 2023",
        eng: "September 2023",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "GitHub Actions is a continuous integration tool that allows developers to automate tasks for their web projects. In this course, learn how to use this powerful tool to build workflows triggered by events, develop a continuous integration and continuous delivery (CI/CD) pipeline, and create custom actions. Instructor Michael Jenkins shows how to create your first actions and then construct a workflow that runs them. He also demonstrates how to use actions from the GitHub Marketplace and public repositories, leverage the capabilities of GitHub Actions to support your CI/CD workflow, and plan and develop custom actions.GitHub Actions is a continuous integration tool that allows developers to automate tasks for their web projects. In this course, learn how to use this powerful tool to build workflows triggered by events, develop a continuous integration and continuous delivery (CI/CD) pipeline, and create custom actions. Instructor Michael Jenkins shows how to create your first actions and then construct a workflow that runs them. He also demonstrates how to use actions from the GitHub Marketplace and public repositories, leverage the capabilities of GitHub Actions to support your CI/CD workflow, and plan and develop custom actions."
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/learning-github-actions-2",
      certurl:
      "https://www.linkedin.com/learning/certificates/c7337767dbabe9259bca2aaaf9f4252ecc98f01d98744815fa34c4b11f72910f?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BDImpVkHSR2GVilCVnh%2B6tQ%3D%3D"
    },
    
    {
      title: {
        pt: "Engenharia DevOps na AWS",
        eng: "DevOps Engineering on AWS",
      },
      duration: {
        pt: "Outubro 2023",
        eng: "October 2023",
      },
      school: {
        pt: "",
        eng: "AWS",
      },
      desc: [
        {
          pt: "",
          eng: "DevOps Engineering on AWS teaches you how to use the combination of DevOps cultural philosophies, practices, and tools to increase your organization’s ability to develop, deliver, and maintain applications and services at high velocity on AWS. This course covers continuous integration (CI), continuous delivery (CD), infrastructure as code, microservices, monitoring and logging, and communication and collaboration. Hands-on labs give you experience building and deploying AWS CloudFormation templates and CI/CD pipelines that build and deploy applications on Amazon Elastic Compute Cloud (Amazon EC2), serverless applications, and container-based applications. Labs for multi-pipeline workflows and pipelines that deploy to multiple environments are also included."
        },

      ],
      courseurl:
      "https://aws.amazon.com/training/classroom/devops-engineering-on-aws/",
    },
    
    {
      title: {
        pt: "Aprender OWASP Top 10",
        eng: "Learning the OWASP Top 10",
      },
      duration: {
        pt: "Janeiro 2024",
        eng: "January 2024",
      },
      school: {
        pt: "",
        eng: "Linkedin Learning",
      },
      desc: [
        {
          pt: "",
          eng: "No organization—no matter how large or small—is invulnerable to security breaches. What makes all of these systems, and the software that runs them, susceptible to attack? The Open Web Application Security Project (OWASP) was formed to provide the public with the resources to understand key risks and improve software security. And every few years, they publish a list of the ten biggest application security vulnerabilities. In this course, application security expert Caroline Wong provides an overview of the 2021 OWASP Top 10, presenting information about each vulnerability category, its prevalence, and its impact. Though aimed at IT security professionals and developers, anyone who uses web applications will benefit from an understanding of these risks."
        },

      ],
      courseurl:
      "https://www.linkedin.com/learning/learning-the-owasp-top-10",
      certurl:
      "https://www.linkedin.com/learning/certificates/b58423652c3d0c69d74d49544bbec30cb6dddaa6ebc72e674b36146961d262f5?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BDImpVkHSR2GVilCVnh%2B6tQ%3D%3D"
    }

  ],
};
